<div class="disclaimer-text">
  <span class="brand">NutriGenic</span> operates exclusively as a <span class="highlight">Subscription-based meal delivery.</span><br>
  Subscriptions can be <span class="highlight">Paused</span> or <span class="highlight">Canceled</span> anytime <span class="highlight">after the second week.</span><br>
  <div class="fm-rubik" style="font-size: 0.857rem; color: #2C2C30;">
                        *By placing your order, you agree to our <u style="cursor: pointer;" (click)="goToTerms()">Terms & Conditions</u>
                    </div>
</div>


